import PermissaoService from "@/services/PermissaoService"

export const actions = {
    cadastrarPermissao: ({commit, dispatch}) => {
        commit('setPermissao', {}),
        dispatch('setModalCadastroPermissao', true)
    },
    listarPermissao: ({commit}, data) => {
        commit('setOverlay', true)
        PermissaoService.listar(data)
        .then(res => {
            commit('setOverlay', false)
            commit('setPermissoes', res.data)
            
        })
        .catch(e => {
            commit('setOverlay', false)
            console.log(e)
        })
    },
    visualizarPermissao: ({commit, dispatch}, data) => {
        commit('setPermissao', data)
        dispatch('setModalCadastroPermissao', true)
    },
    
    salvarPermissao: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        PermissaoService.salvar(data)
        .then(res => {
            commit('setPermissao', res.data)
            // commit('addPermissao', res.data)
            dispatch('listarPermissao')
            commit('setOverlay', false)
            commit('snackbarSuccess', 'Permissão cadastrada.')
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao cadastrar.')
        })
    },
    atualizarPermissao: ({commit, dispatch}, data) => {
        commit('setOverlay', true)
        PermissaoService.atualizar(data)
        .then(res => {
            dispatch('listarPermissao')
            commit('setOverlay', false)
            commit('snackbarInfo', 'Permissão atualizada.')
        })
        .catch(e => {
            if(e.response.status == 422){
                commit('alertError', e.response.data.errors)
            }
            console.log(e)
            commit('setOverlay', false)
            commit('snackbarError', 'Erro ao atualizar.')
        })
    },
    excluirPermissao: ({commit, dispatch}, data) => {
        dispatch('setModalExcluirPermissao', false)
        dispatch('setModalCadastroPermissao', false)
        commit('setOverlay', true)
        PermissaoService.excluir(data.id)
        .then(res => {
            commit('setOverlay', false)
            commit('removePermissao', res.data)
            commit('snackbarError', 'Permissão excluída.')
        })
        .catch(e => {
            commit('snackbarError', 'Erro ao excluir permissão.')
        })
    },
    setModalCadastroPermissao: ({commit}, status) => {
        commit('setModalCadastrarPermissao', false)
        setTimeout(() => {
            commit('setModalCadastrarPermissao', status)
        }, 100);
    },
    setModalExcluirPermissao: ({commit}, status) => {
        commit('setModalExcluirPermissao', false)
        setTimeout(() => {
            commit('setModalExcluirPermissao', status)
        }, 100);
    },
}

export default {}